module.exports = __webpack_public_path__ + "static/family-meals-83d84db944b1355767cb8783827dd0dd.jpg";